/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_MarcaCarga as MarcaCarga,
  rec_Modal as Modal,
  rec_React as React,
  rec_Ro as Ro,
  rec_api as api,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function FormularioProveedor({ editar: e, onClose: t, onGuardado: n }) {
  let [r, i] = (0, React.useState)(e?.nombre ?? ``),
    [a, o] = (0, React.useState)(e?.ruc ?? ``),
    [s, c] = (0, React.useState)(!e || e.activo),
    [l, u] = (0, React.useState)(``),
    [f, p] = (0, React.useState)(!1);
  async function m(t) {
    if ((t.preventDefault(), !f)) {
      (p(!0), u(``));
      try {
        (await api(`/transporte/proveedores`, {
          method: `POST`,
          body: JSON.stringify({
            id: e?.id ?? null,
            nombre: r.trim(),
            ruc: a,
            activo: s,
          }),
        }),
          n());
      } catch (e) {
        u(e.message);
      } finally {
        p(!1);
      }
    }
  }
  return (
    <Modal
      titulo={e ? e.nombre : `Nuevo proveedor`}
      onClose={t}
      children={
        <form
          onSubmit={m}
          aria-label={`Proveedor`}
          className={`flex flex-col gap-3`}
          children={[
            <label
              className={`flex flex-col gap-1 text-sm text-(--text)`}
              children={[
                `Razón social`,
                <input
                  autoFocus={!0}
                  value={r}
                  onChange={(e) => i(e.target.value)}
                  className={Lo}
                />,
              ]}
            />,
            <label
              className={`flex flex-col gap-1 text-sm text-(--text)`}
              children={[
                `RUC`,
                <input
                  value={a}
                  onChange={(e) => o(e.target.value)}
                  placeholder={`20123456789`}
                  inputMode={`numeric`}
                  className={Lo}
                />,
              ]}
            />,
            e && (
              <MarcaCarga
                checked={s}
                onChange={c}
                children={`Se le pueden asignar unidades`}
              />
            ),
            l && <p className={`text-sm text-(--error)`} children={l} />,
            <div
              className={`flex justify-end gap-2`}
              children={[
                <button
                  type={`button`}
                  onClick={t}
                  className={zo}
                  children={`Cancelar`}
                />,
                <button
                  type={`submit`}
                  disabled={f || !r.trim()}
                  className={Ro}
                  children={f ? `Guardando…` : `Guardar`}
                />,
              ]}
            />,
          ]}
        />
      }
    />
  );
}
